import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const rateZoneTypesAdapter = getAdapter({idFieldName: 'value'} );

const rateZoneTypesSlice = createSlice({
    name: 'rateZoneTypes',
    initialState: rateZoneTypesAdapter.getInitialState(),
    reducers: {
        setRateZoneTypes: (state, {payload: {rateZoneTypes}}) => {
            rateZoneTypesAdapter.setAll(state, rateZoneTypes);
        }
    }
});

const selectors = rateZoneTypesAdapter.getSelectors(({rateZoneTypes}) => rateZoneTypes);

export const getRateZoneTypes = state =>  selectors.selectAll(state);

export const {setRateZoneTypes} = rateZoneTypesSlice.actions;
export default rateZoneTypesSlice.reducer;